// 座標とアイテムの重なり判定に使う許容半径(mm)
// 重なりアイテムリスト表示、および選択中アイテムを他アイテムのmousedownから保護する判定の両方で共有する
export const OVERLAP_HITTEST_RADIUS_MM: number = 400;

// 3D座標(m)と2D寸法(mm)の変換係数
export const MM_PER_M: number = 1000;

// 天井高さ・建具の高さ・取付高さの入力上限(mm)
// 天井が3D表示できる高さ（1F床から2Fスラブまでの2840未満）に合わせる
export const CEILING_FITTING_MAX_HEIGHT_MM: number = 2839;

// 住設・家具以外のアイテムの幅・奥行の入力下限(mm)
export const MIN_ITEM_PLAN_SIZE_MM: number = 100;

// 住設・家具の幅・奥行の入力下限(mm)。2D・3Dの数値入力で共有する
export const MIN_HEIGHT_EDITABLE_ITEM_PLAN_SIZE_MM: number = 1;

// 住設・家具の高さの下限(mm)
export const MIN_ITEM_HEIGHT_MM: number = 1;

// 住設・家具の設置高さの下限(mm)。床面に置く 0 を許す
export const MIN_INSTALLATION_HEIGHT_MM: number = 0;

// 作図ビュー（スクロールコンテナ兼SVGの親）の要素ID
export const WEBCAD_2D_VIEW_INNER_ID: string = 'webcad2dViewInner';

// 作図ビュー直下のSVG要素（スクロールコンテンツ本体）のセレクタ
export const WEBCAD_2D_VIEW_SVG_SELECTOR: string = `#${WEBCAD_2D_VIEW_INNER_ID} > svg`;

// 寸法線の表示切り替えボタン（ヘッダーの通常タブとシェアモード用タブ）のセレクタ
export const MEASURE_LINE_TOGGLE_BUTTON_SELECTOR = '#checkMeasureLine, #checkMeasureLineShare';

// ピンの表示切り替えボタン（ヘッダーの通常タブとシェアモード用タブ）のセレクタ
export const PIN_TOGGLE_BUTTON_SELECTOR = '#checkPin, #checkPinShare';

// モード番号
export const ACTIONMODE_CONTROL_STAGE: number = 0;

export const ACTIONMODE_SELECT_ITEM: number = 1;

export const ACTIONMODE_SELECT_SITE: number = 2;

export const ACTIONMODE_INPUT_POINT_SITE: number = 3;

export const ACTIONMODE_INPUT_POINT_ROOM: number = 4;

export const ACTIONMODE_INPUT_DRAG_ROOM: number = 5;

export const ACTIONMODE_INPUT_DRAG_FITTING: number = 6;

export const ACTIONMODE_INPUT_POINT_ROOF: number = 7;

export const ACTIONMODE_INPUT_TOUCH_MOBILE: number = 8;

export const ACTIONMODE_INPUT_ROOM_SKETCH: number = 9;

export const ACTIONMODE_INPUT_FREE_CHARACTER: number = 10;

export const ACTIONMODE_INPUT_WALL: number = 11;

export const ACTIONMODE_INPUT_PIN_TEXT: number = 12;

export const ACTIONMODE_INPUT_PIN_PANORAMA: number = 13;

// モード番号
export const MODE_SHITAE_NO: number = 0;

export const MODE_SITE_NO: number = 1;

export const MODE_EXTERIOR_NO: number = 2;

export const MODE_STAIR_NO: number = 3;

export const MODE_ROOM_NO: number = 4;

export const MODE_FITTING_NO: number = 5;

export const MODE_EQUIPMENT_NO: number = 6;

export const MODE_FURNITURE_NO: number = 7;

export const MODE_PRESENT_NO: number = 8;

export const MODE_MEASURE_NO: number = 9;

export const MODE_ROOMNAME_NO: number = 10;

export const MODE_GROUP_NO: number = 11;

export const MODE_UPSTAIR_NO: number = 12;

export const MODE_ROOMDOWN1_NO: number = 13;

export const MODE_ROOMDOWN2_NO: number = 14;

export const MODE_FITTINGDOWN1_NO: number = 15;

export const MODE_ROOF_NO: number = 16;

export const MODE_WALL_NO: number = 17;

export const MODE_COLUMN_NO: number = 18;

export const MODE_FREETEXT_NO: number = 19;

export const MODE_BEAM_NO: number = 20;

export const MODE_MARK_NO: number = 21;

export const MODE_LIDAR_NO: number = 22;

// モードキー
export const MODE_SHITAE_KEY: string = 'shi';

export const MODE_SITE_KEY: string = 'sit';

export const MODE_EXTERIOR_KEY: string = 'ext';

export const MODE_STAIR_KEY: string = 'str';

export const MODE_ROOM_KEY: string = 'rom';

export const MODE_FITTING_KEY: string = 'fit';

export const MODE_EQUIPMENT_KEY: string = 'equ';

export const MODE_FURNITURE_KEY: string = 'fur';

export const MODE_PRESENT_KEY: string = 'prs';

export const MODE_MEASURE_KEY: string = 'mes';

export const MODE_ROOMNAME_KEY: string = 'rnm';

export const MODE_GROUP_KEY: string = 'grp';

export const MODE_UPSTAIR_KEY: string = 'ust';

export const MODE_ROOMDOWN1_KEY: string = 'rd1';

export const MODE_ROOMDOWN2_KEY: string = 'rd2';

export const MODE_FITTINGDOWN1_KEY: string = 'fd1';

export const MODE_ROOF_KEY: string = 'rof';

export const MODE_WALL_KEY: string = 'wal';

export const MODE_COLUMN_KEY: string = 'col';

export const MODE_FREETEXT_KEY: string = 'txt';

export const MODE_BEAM_KEY: string = 'bem';

export const MODE_MARK_KEY: string = 'mrk';

export const MODE_LIDAR_KEY: string = 'ldr';

// 日本語名称
export const MODE_SHITAE_NAME: string = '下絵';

export const MODE_SITE_NAME: string = '敷地';

export const MODE_EXTERIOR_NAME: string = 'エクステリア';

export const MODE_STAIR_NAME: string = '階段';

export const MODE_ROOM_NAME: string = '部屋';

export const MODE_FITTING_NAME: string = '建具';

export const MODE_EQUIPMENT_NAME: string = '住宅設備';

export const MODE_FURNITURE_NAME: string = '家具';

export const MODE_PRESENT_NAME: string = 'プレゼン';

export const MODE_MEASURE_NAME: string = '寸法線';

export const MODE_ROOMNAME_NAME: string = '部屋名';

export const MODE_GROUP_NAME: string = 'グループ';

export const MODE_UPSTAIR_NAME: string = '上階段';

export const MODE_ROOMDOWN1_NAME: string = 'ポーチ等';

export const MODE_ROOMDOWN2_NAME: string = '廊下等';

export const MODE_FITTINGDOWN1_NAME: string = '開口';

export const MODE_ROOF_NAME: string = '屋根';

export const MODE_WALL_NAME: string = '壁';

export const MODE_COLUMN_NAME: string = '柱';

export const MODE_FREETEXT_NAME: string = 'テキスト';

export const MODE_BEAM_NAME: string = '梁';

export const MODE_LIDAR_NAME: string = '追加ピン';

// 英語名称
export const MODE_SHITAE_NAME_ENG: string = 'shitae';

export const MODE_SITE_NAME_ENG: string = 'site';

export const MODE_EXTERIOR_NAME_ENG: string = 'exterior';

export const MODE_STAIR_NAME_ENG: string = 'stair';

export const MODE_ROOM_NAME_ENG: string = 'room';

export const MODE_FITTING_NAME_ENG: string = 'fitting';

export const MODE_EQUIPMENT_NAME_ENG: string = 'equipment';

export const MODE_FURNITURE_NAME_ENG: string = 'furniture';

export const MODE_PRESENT_NAME_ENG: string = 'present';

export const MODE_MEASURE_NAME_ENG: string = 'measure';

export const MODE_ROOMNAME_NAME_ENG: string = 'roomname';

export const MODE_GROUP_NAME_ENG: string = 'group';

export const MODE_UPSTAIR_NAME_ENG: string = 'upstair';

export const MODE_ROOMDOWN1_NAME_ENG: string = 'roomdown1';

export const MODE_ROOMDOWN2_NAME_ENG: string = 'roomdown2';

export const MODE_FITTINGDOWN1_NAME_ENG: string = 'fittingdown1';

export const MODE_ROOF_NAME_ENG: string = 'roof';

export const MODE_WALL_NAME_ENG: string = 'wall';

export const MODE_COLUMN_NAME_ENG: string = 'column';

export const MODE_FREETEXT_NAME_ENG: string = 'text';

export const MODE_BEAM_NAME_ENG: string = 'beam';

export const MODE_MARK_NAME_ENG: string = 'mark';

export const MODE_LIDAR_NAME_ENG: string = 'addpin';

// サイト編集モード
export const SITE_EDIT_TRIANGULAR_INPUT: number = 0;

export const SITE_EDIT_COORDINATE_INPUT: number = 1;

export const SITE_EDIT_FREE_INPUT: number = 2;

export const SITE_SIMPLE_INPUT_MODE: number = 0;

export const SITE_DETAILED_INPUT_MODE: number = 1;

// 敷地塗りの色
export const SITE_COLOR: number = 0xECF2CE;

export const SITE_ALPHA: number = 0.5;

export const ALMOST_ZERO = 0.0001;

export const AREA_ZERO = 0.0001;

export const DEFAULT_MINIMUM_DEPTH = 100;

// ユニットバス（UB）のアイテムIDと、LiDAR取込で生成するときの高さ初期値(mm)
export const UNIT_BATH_ITEM_ID: string = 'equ07_01';
export const UNIT_BATH_DEFAULT_HEIGHT: number = 2000;
// LiDARデータでUBに変換されるオブジェクトのカテゴリ名
export const LIDAR_CATEGORY_BATHTUB: string = 'bathtub';

// モード番号
export const BUILDING_TYPE_HOUSE: number = 0;
export const BUILDING_TYPE_MANSION: number = 1;

// 寸法補正（撮影アプリJSON・保存データの dimension_correction）
export const DIMENSION_CORRECTION_FREE: number = 0;   // フリー寸法
export const DIMENSION_CORRECTION_MODULE: number = 1; // モジュール補正（ピッチ）

export const FREETEXT_ITEMCODE = '01_01';
export const PINTEXT_MINWIDTH = 240;
export const PINTEXT_MAXWIDTH = 300;
export const PINTEXT_MINHEIGHT = 120;
export const PINTEXT_MAXHEIGHT = 300;
export const PINTEXT_PIN_WIDTH = 24;
export const PINTEXT_PIN_HEIGHT = 27;
export const PINTEXT_HEADER_HEIGHT = 40;
export const PINTEXT_BODY_COLOR = '#f4f4f4f2';
export const WALLPINTEXT_Z = 1500;

export const PINPANORAMA_ITEMCODE = '04_01';

export const PINPICTURE_WIDTH = 24;
export const PINPICTURE_HEIGHT = 25;
export const PINPICTURE_MAXWIDTH = 520; // 440;
export const PINPICTURE_MAXHEIGHT = 640; // 700;

export const PINPICTURE3D_MAXWIDTH = 182;
export const PINPICTURE3D_MAXHEIGHT = 280;

export const MODE_ROOM_PARTS_LIST_NO = 1;
export const MODE_FITTING_LIST_NO = 2;
export const MODE_EQUIPMENT_FURNITURE_LIST_NO = 3;
export const MODE_EXTERIOR_LIST_NO = 4;
export const MODE_AUXILIARY_LIST_NO = 5;
export const QUOTATION_ITEM_LIST_MODE = {
  MODE_ROOM_PARTS_LIST_NO,
  MODE_FITTING_LIST_NO,
  MODE_EQUIPMENT_FURNITURE_LIST_NO,
  MODE_EXTERIOR_LIST_NO,
  MODE_AUXILIARY_LIST_NO,
};

export const MODE_WALL_TYPE_NO = 1;
export const MODE_FLOOR_TYPE_NO = 2;
export const MODE_CEILING_TYPE_NO = 3;
export const MODE_BEAM_TYPE_NO = 4;
export const MODE_COLUMN_TYPE_NO = 5;
export const MODE_FITTING_TYPE_NO = 6;
export const MODE_EQUIPMENT_TYPE_NO = 7;
export const MODE_FURNITURE_TYPE_NO = 8;
export const MODE_HABAKI_TYPE_NO = 9;
export const MODE_EXTERIOR_TYPE_NO = 10;
export const MODE_AUXILIARY_TYPE_NO = 11;
export const QUOTATION_ITEM_LIST_TYPE_MODE = {
  MODE_WALL_TYPE_NO,
  MODE_FLOOR_TYPE_NO,
  MODE_CEILING_TYPE_NO,
  MODE_BEAM_TYPE_NO,
  MODE_COLUMN_TYPE_NO,
  MODE_FITTING_TYPE_NO,
  MODE_EQUIPMENT_TYPE_NO,
  MODE_FURNITURE_TYPE_NO,
  MODE_HABAKI_TYPE_NO,
  MODE_EXTERIOR_TYPE_NO,
  MODE_AUXILIARY_TYPE_NO,
};

// モード番号
export const CONTROL_ACTIONMODE = {
  ACTIONMODE_CONTROL_STAGE,
  ACTIONMODE_SELECT_ITEM,
  ACTIONMODE_SELECT_SITE,
  ACTIONMODE_INPUT_POINT_SITE,
  ACTIONMODE_INPUT_POINT_ROOM,
  ACTIONMODE_INPUT_DRAG_ROOM,
  ACTIONMODE_INPUT_DRAG_FITTING,
  ACTIONMODE_INPUT_POINT_ROOF,
  ACTIONMODE_INPUT_TOUCH_MOBILE,
  ACTIONMODE_INPUT_ROOM_SKETCH,
  ACTIONMODE_INPUT_FREE_CHARACTER,
  ACTIONMODE_INPUT_PIN_TEXT,
  ACTIONMODE_INPUT_PIN_PANORAMA,
  ACTIONMODE_INPUT_WALL,
};

// モード番号
export const ITEM_MODE_NO = {
  MODE_SHITAE_NO,
  MODE_SITE_NO,
  MODE_EXTERIOR_NO,
  MODE_STAIR_NO,
  MODE_ROOM_NO,
  MODE_FITTING_NO,
  MODE_EQUIPMENT_NO,
  MODE_FURNITURE_NO,
  MODE_PRESENT_NO,
  MODE_MEASURE_NO,
  MODE_ROOMNAME_NO,
  MODE_GROUP_NO,
  MODE_UPSTAIR_NO,
  MODE_ROOMDOWN1_NO,
  MODE_ROOMDOWN2_NO,
  MODE_FITTINGDOWN1_NO,
  MODE_ROOF_NO,
  MODE_WALL_NO,
  MODE_COLUMN_NO,
  MODE_FREETEXT_NO,
  MODE_BEAM_NO,
  MODE_MARK_NO,
  MODE_LIDAR_NO,
};

// モードキー
export const ITEM_MODE_KEY = {
  MODE_SHITAE_KEY,
  MODE_SITE_KEY,
  MODE_EXTERIOR_KEY,
  MODE_STAIR_KEY,
  MODE_ROOM_KEY,
  MODE_FITTING_KEY,
  MODE_EQUIPMENT_KEY,
  MODE_FURNITURE_KEY,
  MODE_PRESENT_KEY,
  MODE_MEASURE_KEY,
  MODE_ROOMNAME_KEY,
  MODE_GROUP_KEY,
  MODE_UPSTAIR_KEY,
  MODE_ROOMDOWN1_KEY,
  MODE_ROOMDOWN2_KEY,
  MODE_FITTINGDOWN1_KEY,
  MODE_ROOF_KEY,
  MODE_WALL_KEY,
  MODE_COLUMN_KEY,
  MODE_FREETEXT_KEY,
  MODE_BEAM_KEY,
  MODE_MARK_KEY,
  MODE_LIDAR_KEY,
};

// 日本語名称
export const ITEM_MODE_NAME = {
  MODE_SHITAE_NAME,
  MODE_SITE_NAME,
  MODE_EXTERIOR_NAME,
  MODE_STAIR_NAME,
  MODE_ROOM_NAME,
  MODE_FITTING_NAME,
  MODE_EQUIPMENT_NAME,
  MODE_FURNITURE_NAME,
  MODE_PRESENT_NAME,
  MODE_MEASURE_NAME,
  MODE_ROOMNAME_NAME,
  MODE_GROUP_NAME,
  MODE_UPSTAIR_NAME,
  MODE_ROOMDOWN1_NAME,
  MODE_ROOMDOWN2_NAME,
  MODE_FITTINGDOWN1_NAME,
  MODE_ROOF_NAME,
  MODE_WALL_NAME,
  MODE_COLUMN_NAME,
  MODE_FREETEXT_NAME,
  MODE_BEAM_NAME,
  MODE_LIDAR_NAME,
};
// 英語名称
export const ITEM_MODE_NAME_ENG = {
  MODE_SHITAE_NAME_ENG,
  MODE_SITE_NAME_ENG,
  MODE_EXTERIOR_NAME_ENG,
  MODE_STAIR_NAME_ENG,
  MODE_ROOM_NAME_ENG,
  MODE_FITTING_NAME_ENG,
  MODE_EQUIPMENT_NAME_ENG,
  MODE_FURNITURE_NAME_ENG,
  MODE_PRESENT_NAME_ENG,
  MODE_MEASURE_NAME_ENG,
  MODE_ROOMNAME_NAME_ENG,
  MODE_GROUP_NAME_ENG,
  MODE_UPSTAIR_NAME_ENG,
  MODE_ROOMDOWN1_NAME_ENG,
  MODE_ROOMDOWN2_NAME_ENG,
  MODE_FITTINGDOWN1_NAME_ENG,
  MODE_ROOF_NAME_ENG,
  MODE_WALL_NAME_ENG,
  MODE_COLUMN_NAME_ENG,
  MODE_FREETEXT_NAME_ENG,
  MODE_BEAM_NAME_ENG,
  MODE_MARK_NAME_ENG,
  MODE_LIDAR_NAME_ENG,
};

// サイト編集モード
export const SITE_EDITMODE = {
  SITE_EDIT_TRIANGULAR_INPUT,
  SITE_EDIT_COORDINATE_INPUT,
  SITE_EDIT_FREE_INPUT,
};

export const SITE_INPUT_MODE = {
  SITE_SIMPLE_INPUT_MODE,
  SITE_DETAILED_INPUT_MODE,
};
